import axios from "axios";
import { axiosApiInstance } from "../App";
import { url } from "./url.service";

const serverUrl = url + "/productCategory";

export const addProductCategory = (formData) => {
  return axiosApiInstance.post(serverUrl + "/", formData);
};

export const getProductCategory = (query) => {
  return axiosApiInstance.get(`${serverUrl}/getProductCategory?${query}`);
};



export const deleteProductCategory = (id) => {
  return axiosApiInstance.delete(`${serverUrl}/deleteById/${id}`);
};

export const updateProductCategory = (formData, id) => {
  return axiosApiInstance.patch(`${serverUrl}/updateById/${id}`, formData);
};
